import { Injectable } from '@angular/core';
import { AngularFireDatabase } from "@angular/fire/database";
import { AngularFireFunctions } from '@angular/fire/functions';
import { LogService } from "./log-servicios";

//import { auth } from 'firebase/app';
import { Observable } from 'rxjs';		//, ReplaySubject 
import { map } from 'rxjs/operators';		//, tap, catchError, first
import { Bloqueo, EstadoSesion } from '../interfaces/arbitro-interfaces';
import { DataEmpresaService } from '../servicios/data-empresa-servicios';
import { DataUserService } from '../servicios/data-user-servicios';

@Injectable({
  providedIn: 'root'
})
export class FireArbitroService {
  constructor(
    private db: AngularFireDatabase,
    private logService: LogService,
    public dataEmpresaService: DataEmpresaService,
    private dataUserService: DataUserService,
    private fireFunc: AngularFireFunctions
  ) { }

  // estado de la sesión otorgada por el árbitro
  es1: EstadoSesion = new EstadoSesion;
  getFireArbitroEstadoSesion$(parSesionId): Observable<EstadoSesion> {
    return this.db.object<EstadoSesion>('easymed/' + this.dataEmpresaService.empAut.prefijoBase +
      '/arbitro/sesion/' + parSesionId)
      .valueChanges()
      .pipe(
        map(faes => {
          if (faes == null) {
            return new EstadoSesion;
          } else {
            this.logService.consoleLog('2', 'CS FA faes service get estado sesión: ' + faes.estado + ', poll: ' + faes.poll);
            this.es1 = faes;
            return this.es1;
          }
        })
      );
  }

  // para indicar al árbitro que sí estoy online. El árbitro marca la sesión como Y o Z y yo debo grabar X
  markOnlineArbitroEstadoSesion$(parSesionId: string): Promise<void> {
    this.logService.consoleLog('2', 'CS FA moaes ' + parSesionId);
    return this.db.list('easymed/' + this.dataEmpresaService.empAut.prefijoBase + '/arbitro/sesion/')
      .update(parSesionId, { "poll": "X" });
  }

  // para saber si tengo comunicación con Firebase en este momento
  getFireConnected$(): Observable<boolean> {
    return this.db.object<object>('.info')
      .valueChanges()
      .pipe(
        map(fol => {
          if (fol["connected"] == true) {
            this.logService.consoleLog('2', 'CS FC fol Online');
          } else {
            this.logService.consoleLog('2', 'CS FC fol Offline');
          }
          return fol["connected"];
        })
      );
  }

  // llama la CF Arbitro para pedir un bloqueo
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  cfFireArbitro$(mail: string, func: string, ses: string, elem: string, ceja: string, id: string, blq: string): Observable<any> {
    const funcArbitro = this.fireFunc.httpsCallable('arbitro');
    return funcArbitro({
      prefijoBase: this.dataEmpresaService.empAut.prefijoBase,
      uid: this.dataUserService.user.uid,
      mail: mail,
      funcion: func,
      sesion: ses,
      elemento: elem,
      ceja: ceja,
      id: id,
      bloqueo: blq
    })
  }

  // bloqueo del registro actual
  //el formato del bloqueo es 
  //20231225_221600_547---20231219_225231_278___ortegalopez@hotmail_com___ZQHuJAibETNjNGNyR3b2hFKhWfz1---0
  //YMD_Hms_SSS bloqueo   sesión que bloquea                                                             confirmar blq
  //                      fecha inicio sesión   mail del usr              uid
  getFireArbitroBloqueoActual$(elem: string, ceja: string, id: string): Observable<string> {
    return this.db.object<Bloqueo>('easymed/' + this.dataEmpresaService.empAut.prefijoBase +
      '/arbitro/bloqueo/' + elem + '_' + ceja + '_' + id)
      .valueChanges()
      .pipe(
        map(bl1 => {
          if (bl1 == null) {
            this.logService.consoleLog('2', 'CS FA faes service get bloqueo actual: Null');
            return '';
          } else {
            this.logService.consoleLog('9', 'CS FA faes service get bloqueo actual: ' + bl1);
            return `${bl1.fechahora}---${bl1.sesion}---${bl1.confirmar.toString()}`;
          }
        })
      );
  }

}

